import axios from 'axios'
const baseUrl = '/api/admin/thumbnail-generator/thumbnails'

export default {
    request: (ids) => {
        return axios.post(`${baseUrl}/request`, {
            ids,
        })
    },
}
